import { WaypointResult } from '~/generated/api-clients-generated'
import type { IPageNode } from '~/models/journey/waypoints'

export class WaypointAutoPilot {
  static use(waypoint: WaypointResult, queryParams: Object = {}, pathParams: string[] = []) {
    const waypointProps = {
      ...WaypointEngine.defaultProps,
      getResult: () => waypoint,
      getQueryParams: () => queryParams,
      getPathParams: () => pathParams
    }
    const { depart, next, skip } = WaypointEngine.use(waypointProps)

    const engage = () => {
      return depart()
    }

    const manoeuvre = (replace: boolean = false) => {
      return skip(replace)
    }

    const getCourse = () => {
      const nextNode = next()
      return getCourseInternal(nextNode)
    }

    const getCourseInternal = (node: any) => {
      // recursively find the next path
      if (_isNil(node)) return node
      if (typeof node === 'string') return node
      if ((node as IPageNode)?.path) return (node as IPageNode).path
      return getCourseInternal(node.getNext())
    }

    return {
      engage,
      manoeuvre,
      getCourse
    }
  }
}
